import * as React from 'react';
import { Switch } from './ad-switch/switch';
import { Placeholder } from './placeholder';
import { Features, PageType } from '../../shared/types/ast';
import ContentMarketingContainer from './content-marketing/content-marketing-container';
import { getConfig } from '../config';
import { render } from 'react-dom';

export type PlacementType = 'ast' | 'shopping' | 'content-marketing';

export type Props = {
    id: string;
    className?: string;
    type: PlacementType;
    grid: boolean;
    showBanners: boolean;
    slotAd?: boolean;
    features?: Features;
};

const { vertical, subvertical, deviceType } = getConfig();

export function Placement(props: Props) {
    const { id, className, type, grid, showBanners, features, slotAd } = props;

    if (showBanners) {
        switch (type) {
            case 'ast': {
                return (
                    <Switch
                        slotAd={slotAd}
                        placementId={id}
                        className={className}
                        grid={grid}
                        vertical={vertical}
                        subvertical={subvertical}
                        deviceType={deviceType}
                        features={features}
                    />
                );
            }

            case 'content-marketing':
                return (
                    <ContentMarketingContainer
                        id={id}
                        pageType={'result' as PageType}
                    />
                );
        }
    }
    return <Placeholder id={id} />;
}

export function renderPlacement(containerId, props: Props) {
    const container = document.getElementById(containerId);
    if (container) {
        // react createRoot
        render(<Placement {...props} />, container);
    }
}
